import { Modal, Spin } from 'antd'
import CustomButton from 'components/atoms/custom-button'
import React from 'react'
import { convertHTMLToString } from 'utils'
const TCModal = ({ open, onClose, content, isLoading }) => {
  return (
    <Modal
      open={open}
      closable={false}
      footer={
        <div className="w-full flex justify-end items-center">
          <CustomButton onClick={onClose} type="plain">
            Tutup
          </CustomButton>
        </div>
      }
      onClose={onClose}
      centered>
      <div className="h-[80vh] overflow-y-auto max-w-xl w-full px-5">
        {isLoading ? <LoadingTnC /> : convertHTMLToString(content)}
      </div>
    </Modal>
  )
}
function LoadingTnC() {
  return (
    <div className="flex justify-center items-center h-full w-full">
      <Spin size="large" spinning></Spin>
    </div>
  )
}
export default TCModal
